import { useQueryWithUserId } from '@northladder/services';

import { B2B_SERVICE_API } from '../b2bApiClient';

/**
 * Query key for tracking enterprise my requests details caching.
 */
export const FETCH_ENT_MY_REQ_DETAILS_QUERY_KEY =
  'enterprise-my-requests-details-query-key';

/**
 * It returns the query for the enterprise requests details.
 */
export function useEnterpriseMyRequestsDetailsQuery(
  id: string,
  activities: boolean = false
) {
  /**
   * Cache stale time for the enterprise requests details to 30 seconds.
   */
  const CACHE_STALE_TIME = 30000;

  const { data, error, isError, isPending, refetch } = useQueryWithUserId({
    queryKey: [FETCH_ENT_MY_REQ_DETAILS_QUERY_KEY, id, activities],
    queryFn: () => B2B_SERVICE_API.fetchEntMyRequestDetails({ id, activities }),
    staleTime: CACHE_STALE_TIME,
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
}
